// Kart-bokmerker (saved views): lagre og hopp mellom interesseområder (AOI-er).
// Persisteres i localStorage (klient-lokalt). Docked GNÅ-panel, ren DOM.
import { sporTekst } from './shell.js';
export interface SavedView { name: string; lon: number; lat: number; zoom: number }

const KEY = 'skade.views';
const MAX_VIEWS = 100;

function load(): SavedView[] {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    if (!Array.isArray(raw)) return [];
    return raw
      .filter((v): v is SavedView => !!v && typeof v.name === 'string'
        && typeof v.lon === 'number' && typeof v.lat === 'number' && typeof v.zoom === 'number')
      .slice(0, MAX_VIEWS);
  } catch { return []; }
}
function save(views: SavedView[]) {
  try { localStorage.setItem(KEY, JSON.stringify(views.slice(0, MAX_VIEWS))); } catch { /* full/utilgjengelig */ }
}

export interface BookmarkHooks {
  current: () => { lon: number; lat: number; zoom: number };
  goto: (v: SavedView) => void;
}

export class BookmarksPanel {
  readonly el: HTMLElement;
  private open = false;
  private views: SavedView[] = load();
  private listEl!: HTMLElement;

  constructor(private hooks: BookmarkHooks) {
    this.el = this.build();
    this.render();
  }

  toggle() { this.open = !this.open; this.el.classList.toggle('open', this.open); if (this.open) this.render(); }

  /** Lagre nåværende kartutsnitt (kalles fra ⌘K/hurtigtast også). */
  saveCurrent() {
    sporTekst({
      tittel: 'Lagre bokmerke',
      tekst: 'Navn på bokmerke (interesseområde):',
      onSvar: (name) => {
        if (!name || !name.trim()) return;
        const c = this.hooks.current();
        this.views.unshift({ name: name.trim().slice(0, 80), lon: c.lon, lat: c.lat, zoom: c.zoom });
        this.views = this.views.slice(0, MAX_VIEWS);
        save(this.views);
        if (!this.open) this.toggle(); else this.render();
      },
    });
  }

  private build(): HTMLElement {
    const p = div('report-composer bookmarks-panel');
    const head = div('report-head');
    head.append(span('report-title', 'Kart-bokmerker'));
    const x = document.createElement('button');
    x.className = 'report-x'; x.textContent = '×'; x.onclick = () => this.toggle();
    head.append(x);
    p.append(head);
    const add = document.createElement('button');
    add.className = 'report-submit'; add.textContent = 'Lagre nåværende utsnitt';
    add.onclick = () => this.saveCurrent();
    p.append(add);
    this.listEl = div('targetlist-list');
    p.append(this.listEl);
    return p;
  }

  private render() {
    this.listEl.innerHTML = '';
    if (!this.views.length) { this.listEl.append(span('checklist-note', 'Ingen bokmerker ennå.')); return; }
    this.views.forEach((v, i) => {
      const row = div('targetlist-row');
      const main = div('checklist-main');
      const title = span('checklist-item-title', v.name);
      title.style.cursor = 'pointer';
      title.onclick = () => this.hooks.goto(v);
      main.append(title, span('checklist-note', `${v.lat.toFixed(3)}, ${v.lon.toFixed(3)} · z${v.zoom.toFixed(1)}`));
      const actions = div('targetlist-actions');
      const del = document.createElement('button');
      del.className = 'targetlist-btn'; del.textContent = '✕';
      del.onclick = () => { this.views.splice(i, 1); save(this.views); this.render(); };
      actions.append(del);
      row.append(main, actions);
      this.listEl.append(row);
    });
  }
}

function div(cls: string): HTMLElement { const e = document.createElement('div'); e.className = cls; return e; }
function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
